<div class="page-container">
  <div class="section organizations-card">
    <div class="header-row flex flex-justify-start flex-align-center gap-sm">
      <app-back-button [ariaLabel]="'org.list.back' | translate" />
      <h2>{{ 'org.list.title' | translate }}</h2>
    </div>

    <div class="scrollable-content">
      <app-organization-list />
    </div>
  </div>
</div>
